import { render, staticRenderFns } from "./BaseNavbar.vue?vue&type=template&id=0d8ff188&"
import script from "./BaseNavbar.vue?vue&type=script&lang=ts&"
export * from "./BaseNavbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports